module.exports = __webpack_public_path__ + "static/media/email.c5c16499.jpg";